module.exports = require("prop-types");


//////////////////
// WEBPACK FOOTER
// external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types","umd":"prop-types"}
// module id = 1
// module chunks = 0